import axios from "./axiosInstance";

export type TReq = {
  url: string;
  method: "POST" | "PUT" | "GET" | "DELETE" | "PATCH" | "OPTIONS";
  service: string;
  params?: object | null;
  data?: object | null;
  authToken?: string | null;
  headers?: object;
  isInterserviceCall?: boolean;
  config?: object;
};

const networkCallWrapper = async ({
  url,
  method,
  service,
  params = null,
  data = null,
  authToken = null,
  headers,
  isInterserviceCall = false,
  config
}: TReq) => {
  try {
    const requestObject = {
      url,
      method,
      service,
      headers,
      isInterserviceCall,
      ...(params ? { params } : {}),
      ...(data ? { data } : {}),
      ...(authToken ? { authToken } : {}),
      ...config
    };
    const request = await axios(requestObject);
    if (request?.status === 204) {
      return {
        success: true
      };
    }
    return request.data;
  } catch (err: any) {
    if (err?.response?.status >= 500) {
      return {
        success: false,
        errors: [
          {
            code: 500,
            text: "Something went wrong! Please try again after some time."
          }
        ]
      };
    }
    return err?.response?.data;
  }
};

export default networkCallWrapper;
